<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>
    <FabColumn>
      <BackButton back_url="login"></BackButton>
    </FabColumn>

    <ion-content>
      <MainTitle text="忘記密碼"></MainTitle>
      <MainSubtitle text="請選擇忘記密碼帳戶的註冊方式"></MainSubtitle>
      <ConfirmButton text="手提電話號碼" position="relative" @click="goByMobile"></ConfirmButton>
<!--      <ConfirmButton text="用戶名稱" position="relative" @click="goByName"></ConfirmButton>-->

    </ion-content>
  </ion-page>
</template>

<script>
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import {IonContent, IonPage} from "@ionic/vue";
import MainTitle from "../components/common/MainTitle";
import MainSubtitle from "../components/common/MainSubtitle";
import ConfirmButton from "../components/common/ConfirmButton";
import BackButton from "../components/common/BackButton";
import router from "../router";
export default {
  name: "ForgetPassword",
  components: {
    BackButton,
    ConfirmButton,
    MainSubtitle,
    MainTitle,
    WhiteBackground,
    Background,
    IonPage,
    IonContent
  },
  methods: {
    goByMobile: function () {
      router.replace('/forgetPasswordByMobile')
    },
    goByName: function () {
      router.replace('/forgetPasswordByName')
    }
  }
}
</script>

<style scoped>

</style>
